import { render, staticRenderFns } from "./LogoFacebookSvg.vue?vue&type=template&id=62fe6de6"
import script from "./LogoFacebookSvg.vue?vue&type=script&lang=js"
export * from "./LogoFacebookSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports